import { FunctionComponent } from 'react'
import { makeStyles, withStyles } from '@material-ui/core'
import { MARGIN, COLOR, FONT, SIZE } from 'constants/styles'
import { CSSProperties } from '@material-ui/styles'

const configCell = (fontSize: number): CSSProperties => {
  return {
    fontFamily: FONT.GOTHIC,
    fontSize,
    fontWeight: 'bold',
    color: COLOR.CONTENT,
  }
}

export default makeStyles({
  root: {
    margin: MARGIN.CONTENT,
  },
  card: {
    backgroundColor: COLOR.CLEAR,
  },
  cell_font_small: configCell(SIZE.CONTENT_SMALL),
  cell_font_large: configCell(SIZE.CONTENT_LARGE),
  link: {
    textDecoration: 'underline',
    color: COLOR.CONTENT,
    '&:hover': {
      color: COLOR.LINK_HOVER,
    },
  },
  link_detail: {
    textDecoration: 'underline',
    color: 'inherit',
    '&:hover': {
      color: COLOR.LINK_HOVER,
    },
  },
  table: {
    width: '100%',
    tableLayout: 'fixed',
  },
})

export const OpacityStyle = (content: FunctionComponent) =>
  withStyles({
    root: {
      backgroundColor: COLOR.CONTENT_BACKGROUND,
      borderBottom: `3px solid ${COLOR.CONTENT_BORDER_BOTTOM}`,
      minWidth: '100px',
      overflowWrap: 'break-word',
    },
  })(content)
